import { Dispatch } from "redux";
import { Action } from "api/action_types/self_order";
import { ActionType } from "api/action_types/self_order";

export const clearSelfOrder = () => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.CLEAR_SELF_ORDER
    });
  }
}

export const clearSelfOrders = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.CLEAR_SELF_ORDERS
    });
  }
}
